import { auth, db, storage } from "../../firebaseConfig"; // Ensure you have storage imported from your Firebase configuration
import { doc, setDoc, getDoc } from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

const uploadFileToStorage = async (file, section = "Section7") => {
  const user = auth.currentUser;
  if (!user) {
    // console.error("No authenticated user.");
    return;
  }

  const storageRef = ref(
    storage,
    `uploads/${user.uid}/ApplicationDetails/${section}/${file.name}`,
  );
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

const deleteFileFromStorage = async (fileName, section = "Section7") => {
  const user = auth.currentUser;
  if (!user) {
    // console.error("No authenticated user. Cannot delete file.");
    return;
  }

  const fileRef = ref(
    storage,
    `uploads/${user.uid}/ApplicationDetails/${section}/${fileName}`,
  );

  try {
    await deleteObject(fileRef);
    // console.log(`Deleted file: ${fileName}`);
  } catch (error) {
    // console.error(`Error deleting file: ${fileName}`, error);
  }
};

const processFiles = async (currentFiles, previousFiles) => {
  if (!currentFiles || currentFiles.length === 0) return [];

  const currentFileNames = new Set(
    currentFiles.map((file) => (file instanceof File ? file.name : file.name)),
  );

  const filesToDelete = (previousFiles || []).filter(
    (prevFile) => !currentFileNames.has(prevFile.name),
  );

  await Promise.all(
    filesToDelete.map((file) => deleteFileFromStorage(file.name)),
  );

  return Promise.all(
    currentFiles.map(async (file) => {
      if (file instanceof File) {
        const fileUrl = await uploadFileToStorage(file);
        return { name: file.name, url: fileUrl };
      } else {
        return file;
      }
    }),
  );
};

export const writeDataS7 = async (formData) => {
  const user = auth.currentUser;
  if (!user) {
    // console.error("No authenticated user. Cannot write Section 7 data.");
    return;
  }

  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Fitness and Propriety",
    );

    const docSnap = await getDoc(docRef);
    const previousData = docSnap.exists() ? docSnap.data() : {};

    // Process each file array
    const uploadedFiles_7_01 = await processFiles(
      formData.files_7_01,
      previousData.files_7_01 || [],
    );
    const uploadedFiles_7_02 = await processFiles(
      formData.files_7_02,
      previousData.files_7_02 || [],
    );
    const uploadedFiles_7_03 = await processFiles(
      formData.files_7_03,
      previousData.files_7_03 || [],
    );
    const uploadedFiles_7_04 = await processFiles(
      formData.files_7_04,
      previousData.files_7_04 || [],
    );
    const uploadedFiles_7_05 = await processFiles(
      formData.files_7_05,
      previousData.files_7_05 || [],
    );

    // Prepare data to save
    const dataToSave = {
      ...formData,
      files_7_01: uploadedFiles_7_01,
      files_7_02: uploadedFiles_7_02,
      files_7_03: uploadedFiles_7_03,
      files_7_04: uploadedFiles_7_04,
      files_7_05: uploadedFiles_7_05,
    };

    await setDoc(docRef, dataToSave, { merge: true });
    // console.log("Section 7 data successfully written!");
  } catch (error) {
    // console.error("Error writing Section 7 data to Firestore: ", error);
  }
};
